import { EmailValidity } from "@accurx/api/clinician-messaging";
import { Ds } from "@accurx/design";
import { useDirectory } from "domains/directory/context/DirectoryProvider";
import { i } from "images";

export const NoResults = ({
    searchTermValidity,
}: {
    searchTermValidity?: EmailValidity | null;
}) => {
    const { setView } = useDirectory();
    const isValidEmailAddress = searchTermValidity === EmailValidity.Valid;

    const handleAddContact = () => setView("AddContact");

    return (
        <Ds.Flex flexDirection="column" alignItems="center">
            <img
                src={i("illustrations/SearchIllustration.svg")}
                alt="Search results"
                height="80"
                aria-hidden="true"
            />

            <Ds.Text weight="bold">No results found</Ds.Text>
            <Ds.Text style={{ whiteSpace: "pre-line" }}>
                {`Try searching again 
                with different details`}
            </Ds.Text>

            {isValidEmailAddress && (
                <Ds.Box mt="2">
                    <Ds.Flex flexDirection="column" gap="1">
                        <Ds.Button
                            appearance="secondary"
                            onClick={handleAddContact}
                        >
                            <Ds.Icon name="Plus" size="small" />
                            Add contact
                        </Ds.Button>

                        <Ds.Button appearance="tertiary">
                            <Ds.Icon
                                name="preview-MessageHealthProfessional"
                                size="small"
                            />
                            Message
                        </Ds.Button>
                    </Ds.Flex>
                </Ds.Box>
            )}
        </Ds.Flex>
    );
};
